import { useNavigate } from 'react-router-dom';
import { Button } from '../components/shared/Button/Button';
import { Calendar } from '../components/Calendar/Calendar';
import { GuestRooms } from '../components/GuestRooms';
import { RateModes } from '../components/RateModes/RateModes';
import { Promocode } from '../components/Promocode/Promocode';
import { StickyBottom } from '../components/shared/StickyBottom/StickyBottom';
import { Heading1, Heading3 } from '../components/shared/Heading';
import { observer } from 'mobx-react-lite';
import { useRootStore } from '../stores/useRootStore';
import { useEffect } from 'react';

export const ParamsSetup = observer(() => {
  const navigate = useNavigate();

  const { configStore, authStore, paramsStore, colorAvailabilityStore } = useRootStore();

  const hotelConfig = configStore.config;

  useEffect(() => {
    colorAvailabilityStore.init();
    return () => colorAvailabilityStore.dispose();
  }, []);

  useEffect(() => {
    if (!configStore.childCategories) {
      return;
    }
    paramsStore.initRange();
    paramsStore.initGuestRooms(configStore.childCategories);
  }, [paramsStore, configStore.childCategories]);

  const searchRooms = async () => {
    navigate('/rooms');
    await paramsStore.loadRooms();
  };

  return (
    <main className="container mx-auto max-w-[1132px]">
      <Heading1 className="mt-8 hidden text-center xl:block">Забронировать отдых</Heading1>

      {authStore.isCompanyEmployee && (
        <section className="border border-neutral-30 px-5 py-8 xl:mb-10 ">
          <Heading3 className="text-center">Тариф</Heading3>
          <div className="space-y-4 xl:flex xl:space-y-0">
            <RateModes />
          </div>
        </section>
      )}

      <section className="container mx-auto mt-6 flex justify-center">
        {paramsStore.range && (
          <Calendar range={paramsStore.range} onChange={range => paramsStore.setRange(range)} />
        )}
      </section>

      <section className="mb-10 mt-10 flex flex-col justify-center xl:flex-row">
        {hotelConfig && (
          <GuestRooms
            guestRooms={paramsStore.guestRooms}
            onChange={paramsStore.setGuestRooms}
            childCategories={hotelConfig.hotel_child_categories}
            maxAdults={hotelConfig.max_adults}
            maxRooms={hotelConfig.max_rooms}
          />
        )}
      </section>

      {configStore.hasPromocode && (
        <section className="mb-10 border border-neutral-30 px-5 py-8">
          <Promocode />
        </section>
      )}

      <StickyBottom>
        <Button
          className="w-full xl:w-auto"
          onClick={searchRooms}
          disabled={!paramsStore.range?.from || !paramsStore.range?.to}
        >
          Подобрать номера
        </Button>
      </StickyBottom>
    </main>
  );
});
